import { Link } from "react-router-dom"
import { Mail, Phone, Clock, MapPin } from "lucide-react"

export default function Footer() {
  // Enhanced footer with dark theme and better styling
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <div className="mb-4">
                <img 
                  src="/logo.jpeg" 
                  alt="Carz Bazzar Logo" 
                  width={120} 
                  height={60} 
                  className="h-16 w-auto"
                />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">Carz Bazzar Franchise</h3>
              <p className="text-gray-300 text-lg leading-relaxed max-w-md">
                Build a profitable used-car business with a trusted brand and verified leads.
              </p>
            </div>
            
            {/* Contact Info */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-blue-400" />
                <a 
                  href="mailto:carsbazzarmain@gmail.com" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  carsbazzarmain@gmail.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-blue-400" />
                <a 
                  href="tel:+919773460662" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  +91 9773460662
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Clock className="w-5 h-5 text-blue-400" />
                <span className="text-gray-300">Mon–Fri, 9am–6pm</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="w-5 h-5 text-blue-400" />
                <span className="text-gray-300">India</span>
              </div>
            </div>
          </div>
          
          {/* Company Links */}
          <div>
            <h4 className="text-xl font-semibold text-white mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/privacy-policy" 
                  className="text-gray-300 hover:text-white transition-colors block"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms-of-service" 
                  className="text-gray-300 hover:text-white transition-colors block"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link 
                  to="/child-safety-policy" 
                  className="text-gray-300 hover:text-white transition-colors block"
                >
                  Child Safety Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/delete-my-account" 
                  className="text-gray-300 hover:text-white transition-colors block"
                >
                  Delete My Account
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-semibold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/" 
                  className="text-gray-300 hover:text-white transition-colors block"
                >
                  Home
                </Link>
              </li>
              <li>
                <a 
                  href="tel:+919773460662" 
                  className="text-gray-300 hover:text-white transition-colors block"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a 
                  href="mailto:carsbazzarmain@gmail.com" 
                  className="text-gray-300 hover:text-white transition-colors block"
                >
                  Support
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Carz Bazzar Franchise. All rights reserved.
            </p>
            <div className="flex items-center space-x-2 text-gray-400 text-sm">
              <span>Made with</span>
              <span className="text-red-500 text-lg">❤️</span>
              <span>by</span>
              <a 
                href="https://www.qikkspace.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-400 hover:text-blue-300 transition-colors font-medium"
              >
                Qikk space
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}